(function() {
  const AREA = 'tpoReloadOverlay';

  function debugEnabled() {
    try {
      return new URLSearchParams(window.location.search).get('happifyDebug') === '1';
    } catch (error) {
      return false;
    }
  }

  function debug(message, data) {
    if (!debugEnabled()) return;
    console.info('[HappifyCustom][' + AREA + '] ' + message, data || '');
  }

  function warn(message, data) {
    if (!debugEnabled()) return;
    console.warn('[HappifyCustom][' + AREA + '] ' + message, data || '');
  }

  try {
    if (!sessionStorage.getItem('tpo-reload-overlay')) return;
    sessionStorage.removeItem('tpo-reload-overlay');

    const existingOverlay = document.getElementById('tpo-reload-overlay');
    if (existingOverlay) existingOverlay.remove();

    const existingStyle = document.getElementById('tpo-reload-overlay-style');
    if (existingStyle) existingStyle.remove();

    const style = document.createElement('style');
    style.id = 'tpo-reload-overlay-style';
    style.textContent = `
      @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap');

      @keyframes tpo-spin {
        to { transform: rotate(360deg); }
      }

      @keyframes tpo-fade-in {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      #tpo-reload-overlay {
        position: fixed;
        inset: 0;
        background: #000;
        z-index: 2147483647;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 28px;
        backdrop-filter: none;
        -webkit-backdrop-filter: none;
        font-family: 'Poppins', sans-serif;
        animation: tpo-fade-in 0.2s ease;
      }

      #tpo-reload-overlay .tpo-logo {
        height: 80px;
        width: auto;
        opacity: 0.95;
        filter: brightness(0) invert(1);
      }

      #tpo-reload-overlay .tpo-spinner {
        width: 64px;
        height: 64px;
        border: 4px solid rgba(255,255,255,0.15);
        border-top-color: #fff;
        border-radius: 50%;
        animation: tpo-spin 0.85s linear infinite;
      }

      #tpo-reload-overlay .tpo-label {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.06em;
        text-align: center;
        padding: 0 32px;
        opacity: 0.92;
      }
    `;
    document.head.appendChild(style);

    const existingLogo = document.querySelector('.header__logo img, .logo img, img[class*="logo"]');
    const logoSrc = existingLogo ? (existingLogo.currentSrc || existingLogo.src) : null;

    const overlay = document.createElement('div');
    overlay.id = 'tpo-reload-overlay';

    if (logoSrc) {
      const logo = document.createElement('img');
      logo.className = 'tpo-logo';
      logo.src = logoSrc;
      logo.alt = 'Logo';
      overlay.appendChild(logo);
    }

    const spinner = document.createElement('div');
    spinner.className = 'tpo-spinner';
    overlay.appendChild(spinner);

    const label = document.createElement('div');
    label.className = 'tpo-label';
    label.textContent = 'Aktualizowanie zestawu\u2026';
    overlay.appendChild(label);

    document.documentElement.appendChild(overlay);

    let stableCount = 0;
    let finished = false;

    function finish(reason, delay) {
      if (finished) return;
      finished = true;
      clearInterval(checkInterval);
      clearTimeout(safetyTimeout);
      debug('remove scheduled', { reason, delay });
      setTimeout(() => {
        overlay.remove();
        style.remove();
      }, delay || 0);
    }

    const checkInterval = setInterval(() => {
      const editBtn = document.querySelector('.tpo_open-modal-button');
      const editBtnReady = editBtn && editBtn.offsetParent !== null && editBtn.offsetWidth > 0;

      if (editBtnReady) {
        stableCount++;
        if (stableCount >= 5) {
          finish('edit-button-stable', 600);
        }
      } else {
        stableCount = 0;
      }
    }, 100);

    const safetyTimeout = setTimeout(() => {
      warn('safety timeout');
      finish('safety-timeout', 0);
    }, 6000);
  } catch (error) {
    try {
      sessionStorage.removeItem('tpo-reload-overlay');
    } catch (_) {}
    warn('failed safely', error);
  }
})();
